import { ActionTypes } from '../actions';

const initialState = null;

const linkReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LINK:
      return action.payload;
    default:
      return state;
  }
};

export default linkReducer;
